function CheckStart({ className }: { className?: string }): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
    >
      <path
        d="M8.8111 21.8653L7.0266 18.8578L3.6381 18.1153L3.96885 14.627L1.67285 12L3.96885 9.37301L3.6381 5.88477L7.0266 5.14227L8.8111 2.13477L11.9996 3.48851L15.1881 2.13477L16.9726 5.14227L20.3611 5.88477L20.0304 9.37301L22.3264 12L20.0304 14.627L20.3611 18.1153L16.9726 18.8578L15.1881 21.8653L11.9996 20.5115L8.8111 21.8653ZM9.4496 19.95L11.9996 18.8693L14.5804 19.95L15.9996 17.55L18.7496 16.9193L18.4996 14.1L20.3496 12L18.4996 9.86927L18.7496 7.05002L15.9996 6.45002L14.5496 4.05002L11.9996 5.13076L9.41885 4.05002L7.9996 6.45002L5.2496 7.05002L5.4996 9.86927L3.6496 12L5.4996 14.1L5.2496 16.95L7.9996 17.55L9.4496 19.95ZM10.9496 15.2038L16.2534 9.90002L15.1996 8.81552L10.9496 13.0655L8.7996 10.9463L7.74585 12L10.9496 15.2038Z"
        fill="#004A68"
      />
    </svg>
  );
}

export default CheckStart;
